import React from "react";
import {
  Document,
  Page,
  Text,
  StyleSheet,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";

// Tamaño de etiqueta: 3 cm de largo x 1.5 cm de ancho (1 cm = 28.3465 pt)
const LABEL_WIDTH = 3 * 28.3465; // ~85.04 pt
const LABEL_HEIGHT = 1.5 * 28.3465; // ~42.52 pt

const styles = StyleSheet.create({
  viewer: {
    width: "100%",
    height: window.innerHeight * 0.75,
  },
  page: {
    padding: 3,
    fontFamily: "Helvetica",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  nombre: {
    fontSize: 5,
    fontFamily: "Helvetica-Bold",
    color: "#000000",
    marginBottom: 1,
    textAlign: "center",
  },
  barcodeImg: {
    width: LABEL_WIDTH - 8,
    height: LABEL_HEIGHT - 14,
    objectFit: "contain",
  },
});

const EtiquetasInsumosPdf = ({ data }) => {
  if (!data || data.length === 0) return null;

  // Devuelve las iniciales del nombre (ej. "Hilo de Algodón Blanco" -> "HAB")
  const getIniciales = (nombre) => {
    if (!nombre) return "";
    return nombre
      .trim()
      .split(/\s+/)
      .map((palabra) => palabra.charAt(0).toUpperCase())
      .join("");
  };

  return (
    <PDFViewer style={styles.viewer}>
      <Document>
        {data.map((item, index) => (
          <Page
            key={index}
            style={styles.page}
            size={[LABEL_WIDTH, LABEL_HEIGHT]}
          >
            <Text style={styles.nombre}>{getIniciales(item.nombre)}</Text>
            {!!item.dataURL && (
              <Image style={styles.barcodeImg} src={item.dataURL} />
            )}
          </Page>
        ))}
      </Document>
    </PDFViewer>
  );
};

export default EtiquetasInsumosPdf;
